import { IconButton, Shadow, Text, HStack, VStack, Stack, Box } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import { SourceAndDestination } from './components/SourceAndDestination';
import { TableContentItemStatus } from './components/TableContentItemStatus';

import { TransferRequestsItemProps } from '.';

export const TransferRequestsItemMobile: React.FC<TransferRequestsItemProps> = ({
  item,
  onPressDetails,
}) => {
  return (
    <Stack
      px={Utils.Responsive.All({
        desktop: 'inline.xxxs',
        tablet: 'inline.xxs',
        phone: 0,
      })}>
      <Shadow level={1} p="inset.xs" borderRadius={BoxBorder.heavy}>
        <VStack space="stack.xxxs">
          <SourceAndDestination
            w="full"
            sourceLogoUrl={item.sourceLogoUrl}
            sourceNameNormalized={item.sourceNameNormalized}
            destinationLogoUrl={item.destinationLogoUrl}
            destinationNameNormalized={item.destinationNameNormalized}
          />
          <VStack space="stack.nano">
            <HStack justifyContent="space-between">
              <Text>Solicitado via</Text>
              <Text>{item.requestedByWayOfNormalized}</Text>
            </HStack>
            <Box h="1px" w="full" bg="neutral.lightest" />
            <HStack justifyContent="space-between">
              <Text>Data de solicitação</Text>
              <Text>{item.requestDateNormalized}</Text>
            </HStack>
            <Box h="1px" w="full" bg="neutral.lightest" />
            <HStack justifyContent="space-between">
              <Text>Protocolo</Text>
              <Text>{item.protocolNormalized}</Text>
            </HStack>
          </VStack>
          <HStack justifyContent="space-between" alignItems="center">
            <TableContentItemStatus statusIcon={item.statusIcon} status={item.status} />
            <IconButton
              alignSelf={'flex-end'}
              testId="details-icon-button"
              icon="ArrowRight"
              onPress={() => onPressDetails(item.protocolNormalized)}
              p={0}
              iconColor="brand.tertiary.principal"
              iconSize="xs"
            />
          </HStack>
        </VStack>
      </Shadow>
    </Stack>
  );
};
